import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[bsClickableCell]',
})
export class ClickableCellDirective implements OnInit {
  constructor(readonly router: Router, readonly elementRef: ElementRef) {}
  @Input() clickableCellClickFn?: (event: MouseEvent, element: any) => void;
  @Input() clickableCellUrl: string[] | undefined;
  @Input() clickableCellQueryParams:
    | ((element: any) => { [key: string]: any })
    | undefined;
  @Input() clickableCellColor: string | undefined;
  @Input() clickableCellWeight: string | undefined;
  @Input() clickableElementData: any;
  @Input() bsClickableCell!: boolean;

  @HostBinding('style.cursor') cursor = 'default';
  @HostListener('click', ['$event']) onClick(event: MouseEvent): void {
    if (!this.bsClickableCell) return;
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (this.clickableCellClickFn)
      return this.clickableCellClickFn(event, this.clickableElementData);

    if (!this.clickableCellUrl) return;
    const queryParams =
      this.clickableCellQueryParams &&
      this.clickableCellQueryParams(this.clickableElementData);

    const routerOptions = queryParams
      ? {
          queryParams: queryParams,
        }
      : {};
    this.router.navigate(this.clickableCellUrl, routerOptions);
  }

  ngOnInit(): void {
    if (this.clickableCellColor)
      this.elementRef.nativeElement.style.color = this.clickableCellColor;
    this.elementRef.nativeElement.style.fontWeight = this.clickableCellWeight;
    this.cursor = this.bsClickableCell ? 'pointer' : 'default';
  }
}
